import { emptyApi } from "./emptyApi";
import { BackendError } from "types/utils/error";

export type BooksLockDateResponse = {
  accounting_lock_date: string;
};

export const booksLockDateApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getBookkeepingSettings: build.query<
      BooksLockDateResponse,
      {
        entityId: string;
      }
    >({
      query: ({ entityId }) => {
        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/bookkeeping_settings/`,
        };
      },
      providesTags: ["BOOKS_LOCK_DATE"],
      transformErrorResponse: (response) => response as BackendError,
    }),

    updateBookkeepingSettings: build.mutation<
      BooksLockDateResponse,
      {
        entityId: string;
        accounting_lock_date: string | null;
      }
    >({
      query: ({ entityId, accounting_lock_date }) => {
        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/bookkeeping_settings/`,
          method: "PUT",
          body: {
            accounting_lock_date,
          },
        };
      },
      invalidatesTags: ["BOOKS_LOCK_DATE"],
      transformErrorResponse: (response) => response as BackendError,
    }),

    getBookkeepingLogs: build.query<
      {
        logs: {
          field_name: string;
          new_value: string;
          old_value: string;
          changed_by: {
            uuid: string;
            email: string;
            name: string;
          };
          created_at: string;
        }[];
      },
      {
        entityId: string;
      }
    >({
      query: ({ entityId }) => {
        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/bookkeeping_settings_log/`,
        };
      },
      providesTags: ["BOOKS_LOCK_DATE"],
      transformErrorResponse: (response) => response as BackendError,
    }),
  }),
});

export const {
  useGetBookkeepingLogsQuery,
  useGetBookkeepingSettingsQuery,
  useUpdateBookkeepingSettingsMutation,
} = booksLockDateApi;
